<script setup lang="ts">
import HelpIconTooltip from '../elements/HelpIconTooltip.vue';

import type { ICustomField } from '@nova/core';

/**
 * Label component for custom fields.
 *
 * Marks a required field from `field.required` itself. The asterisk used to come from a global
 * `.required label:after` rule on an ancestor, which also marked every label nested inside the
 * field, such as the Yes/No text of a switch.
 */
const { field, htmlFor } = defineProps<{
  field: ICustomField;
  htmlFor?: string;
}>();
</script>

<template>
  <label class="d-flex flex-row align-center ga-1 custom-field-label" :for="htmlFor">
    <span class="typography-body-sm-bold text--color-text-primary">{{ field.label }}</span>
    <span v-if="field.required" class="custom-field-label__required text--color-text-error">*</span>

    <help-icon-tooltip v-if="field.description">
      {{ field.description }}
    </help-icon-tooltip>
    <slot name="append"></slot>
  </label>
</template>
